export default Object.freeze({
  Automy: 1,
  Distributor: 2,
});
